<template>
  <div class="cpt-dialog">
    <t-dialog header="表达式编辑" v-model:visible="cptFunShow" :closeOnOverlayClick="false" @CloseBtnClick="closeBtnClick"
      @Cancel="closeBtnClick" @Confirm="confirm">
      <t-row class="fun_top">
        <t-col :flex="5">
          <div class="fun_top_flex">
            <div :class="{ 'fun_header': true, 'result-error': errorText }" v-if="errorText">{{ errorText }}</div>
            <div class="fun_header" v-else>请在下面的编辑框内输入公式</div>
            <div class="cpt_textarea">
              <template v-if="commonFunctionShow">
                <textarea id="textarea" ref="textarea" v-model="funcValue" />
              </template>
              <template v-else>
                <textarea id="inputStart" v-model="option.defaultValue" v-if="!endShow" @blur="textareaBlur" />
                <textarea id="inputEnd" v-model="option.defaultValueEnd" v-else @blur="textareaBlur" />
              </template>
            </div>
          </div>
        </t-col>
        <t-col :flex="1.5">
          <div class="fun_top_flex none_right">
            <div class="fun_header">操作符</div>
            <div class="fun_header_title">
              <div class="cpt_btn">
                <div class="cpt_btn_item" @click="onClickFunOperator(operItem)"
                  v-for="(operItem, operIndex) in operator" :key="operIndex">
                  <div>{{ operItem.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </t-col>
      </t-row>
      <t-row :gutter="6" class="fun_bottom">
        <t-col :flex="2">
          <div class="fun_bottom_flex">
            <div class="fun_header">函数类型</div>
            <div class="fun_name">
              <div class="fun_name_item" v-for="(item, index) in funTypeData" :key="index"
                @click.stop="clickFunType(item, index)" :class="{ active: funTypeIndex == index }">
                {{ item.label }}
              </div>
            </div>
          </div>
        </t-col>
        <t-col :flex="2">
          <div class="fun_bottom_flex">
            <div class="fun_header">函数名</div>
            <div class="fun_name">
              <div class="fun_name_item" v-for="(ele, eindex) in funNameData" :key="eindex"
                @click.stop="clickFunName(ele, eindex)" :class="{ active: funNameIndex == eindex }"
                @dblclick="fillValue(ele)">
                {{ ele.title }}
              </div>
            </div>
          </div>
        </t-col>
        <t-col :flex="2">
          <div class="fun_bottom_flex">
            <div class="fun_header">
              数据集
              <!-- <t-form-item label="当前大屏">
                <t-switch style="margin-left: 30px;" @change="getSqlListApi" v-model="searchForm.currentSql" size="small">
                  <template #label="slotProps">{{ slotProps.value ? '开' : '关' }}</template>
                </t-switch>
              </t-form-item> -->
            </div>
            <div class="fun_name" v-if="funTypeIndex === 2 && sqlTableData.length">
              <div class="fun_name_item" v-for="(ele, eindex) in sqlTableData" :key="ele.id"
                @click.stop="clickDataset(ele, eindex)" :class="{ active: datasetIndex == eindex }">
                <span>{{ ele.datasetName }}</span>
              </div>
            </div>
          </div>
        </t-col>
        <t-col :flex="2">
          <div class="fun_bottom_flex">
            <div class="fun_header">变量</div>
            <div class="variables-wrap" v-if="funTypeIndex === 1">
              <div class="variables-item" v-for="(item, index) in functionVariables" :key="index">
                <div :class="{ 'variables-title': true, 'active-title': item.isOpen }" @click="onOpenVariables(item)">
                  <span>{{ item.name }}</span>
                  <i>- [{{ item?.children.length }}]</i>
                </div>
                <div :class="{ 'variables-item-children': true, 'is-open': item.isOpen }"
                  :style="{ '---height': item.childrenHeight }">
                  <div class="variables-item-title" @dblclick="onClickVariables(cItem)"
                    v-for="(cItem, cIndex) in item?.children" :key="cIndex">
                    <span>{{ cItem.field }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="variables-wrap" v-else>
              <template v-if="funTypeIndex === 2">
                <div class="variables-item" v-for="(ele, eindex) in datasetVariables" :key="eindex"
                  :class="{ active: datasetValueIndex == eindex }" @click="clickDatasetValues(ele, eindex)"
                  @dblclick="onClickVariables(ele)">
                  {{ ele.COLUMN_NAME }}
                </div>
              </template>
            </div>
          </div>
        </t-col>
        <t-col :flex="3">
          <div class="fun_bottom_flex">
            <div class="fun_header">公式说明</div>
            <div class="fun_p" v-html="funDes"></div>
          </div>
        </t-col>
      </t-row>
    </t-dialog>
  </div>
</template>

<script>
import data from "@/assets/fundata.json"; //函数静态数据
import { pageListApi as sqlListApi, getDetailApi } from "@/api/dataset/dataset-sql";
import { executeSelectKey } from "@/api/sql-execute-api";
import { CommonFuncCalculate, DatasetFuncValue } from '@/utils/func.js';
export default {
  name: "cpt-fun",
  data() {
    return {
      cptFunShow: false,
      funTypeData: [], //区域1
      funNameData: [], //区域2
      funDes: "", //区域4
      funTypeIndex: 0,
      funNameIndex: 0,
      operator: [
        { label: "+", value: "+" },
        { label: "-", value: "-" },
        { label: "*", value: "*" },
        { label: "/", value: "/" },
        // { label: "=", value: "=" },
        // { label: "!=", value: "!=" },
        // { label: ">", value: ">" },
        // { label: "<", value: "<" },
        // { label: ">=", value: ">=" },
        // { label: "<=", value: "<=" },
        // { label: "||", value: "||" },
        // { label: "&&", value: "&&" },
      ],
      option: "", // 打开函数公共弹窗接收值
      currentCpt: {},// 当前组件
      cptOption: {},
      endShow: false,
      selectedText: "",
      autofocus: false,
      curEventObj: "",
      commonFunctionShow: false, // 常用函数
      funcValue: '',
      functionVariables: [], // 变量
      errorText: '',
      // 数据集
      cacheComponents: [],
      searchForm: { datasetName: "", datasourceId: "", currentSql: true },
      pageConfig: {
        pageNo: 1,
        pageSize: 99999,
      },
      sqlTableData: [],
      selectedDataset: {},
      datasetIndex: 0,
      datasetVariables: [],
      selectedDatasetValue: {},
      datasetValueIndex: 0
    };
  },
  watch: {
    //监控函数数据
    datas: {
      handler(obj) {
        console.log(obj);
        this.funTypeData = obj.funData;
      },
      deep: true,
    },
    funcValue(newVal, oldVal) {

      if ((newVal != oldVal) && this.commonFunctionShow) {
        this.onChangeTextarea()
      }
    }
  },

  mounted() {
    // 进入函数公共弹窗，默认打开第一个函数
    this.funTypeData = data.funData;
    this.funNameData = data.funData[0].data;
    this.funDes = data.funData[0].data[0].des;
  },
  // autofocus在弹窗中无效 https://juejin.cn/post/7129777961275752479
  updated() {

    this.$nextTick(() => {
      if (this.commonFunctionShow) {

      } else if (this.cptFunShow) {
        if (this.endShow) {
          //  this.$refs.inputEnd.focus();
          document.getElementById('inputEnd').focus();
        } else {
          //  this.$refs.inputStart.focus();
          document.getElementById('inputStart').focus();
        }
      }
    });
  },
  created() {
  },
  methods: {
    opened(item, type, items) {
      // console.log(item,type,items,"open111111")
      if (type == "end") {
        this.endShow = true;
      } else if (type === "commonFunction") {
        // 常用函数
        this.commonFunctionShow = true
        this.funcValue = item.attribute.functionResult.function || ''
        this.getFunctionVariables(item)
      } else {
        this.endShow = false;
        this.commonFunctionShow = false
      }
      this.cacheComponents = item.cacheComponents;
      this.option = item.attribute;
      this.currentCpt = item.currentCpt;
      this.cptOption = item.currentCpt.cptOption;
      this.curEventObj = items// 存数据，取消还原
      this.funTypeIndex = 0;
      this.funNameIndex = 0;
      this.funNameData = data.funData[0].data;
      this.funDes = data.funData[0].data[0].des;
      this.cptFunShow = true;
      // 获取数据集
      this.getSqlListApi()
    },
    // 获取数据集
    getSqlListApi() {
      this.sqlTableData = [];
      if (this.searchForm.currentSql) {
        this.filterSqlTableData();
      } else {
        sqlListApi(Object.assign(this.searchForm, this.pageConfig)).then(res => {
          if (res.code == 200) {
            this.sqlTableData = res.data.records;
          } else {
            console.log('获取数据集失败');
          }
        })
      }
    },
    async filterSqlTableData() {
      let datasetIds = this.cacheComponents?.map(item => {
        if (item.cptOption.cptDataForm && item.cptOption.cptDataForm.hasOwnProperty('datasetId')) {
          const datasetId = item.cptOption.cptDataForm.datasetId
          return datasetId?.includes(',') ? null : datasetId
        }
      })
        .filter(x => x);
      datasetIds = Array.from(new Set(datasetIds))
      let result = await this.filterSqlTableDetail(datasetIds)
      this.sqlTableData = result
    },
    // 过滤当前大屏数据集
    async filterSqlTableDetail(components) {
      const allPromise = components.map(async id => {
        try {
          const resItem = await getDetailApi(id);
          return resItem.data;
        } catch (err) {
          console.error('合计组件数据集查询失败:', err);
        }
      });
      const resultArray = await Promise.all(allPromise);
      return resultArray;
    },
    // 选择单个数据集
    clickDataset(dataset, i) {
      this.selectedDataset = dataset;
      this.cptOption.cptDataForm.dataSource = '4';
      this.cptOption.cptDataForm.datasetType = 'sql';
      this.cptOption.cptDataForm.datasetId = dataset.id;
      this.cptOption.cptDataForm.datasetName = [dataset.datasetName];
      this.datasetIndex = i;
      let iptstr = dataset.sqlText;
      if (!iptstr) {
        return;
      }
      executeSelectKey({
        sql: iptstr,
        datasourceId: dataset.datasourceId,
        isArray: true,
      }).then(res => {
        this.datasetVariables = res.data;
        this.cptOption.cptDataForm.dataSetData = res.data;
      })
    },
    // 选择单个数据单个变量
    clickDatasetValues(value, i) {
      this.selectedDatasetValue = value;
      this.datasetValueIndex = i
    },
    clickFunType(ele, index) {
      // 点1切换2，4
      this.funNameData = ele.data;
      this.funTypeIndex = index;
      this.funDes = ele.data[0].des;
      if (this.funTypeIndex == 2) {
        this.commonFunctionShow = true
      }
    },
    clickFunName(ele, eindex) {
      // 点2切换4
      this.funDes = ele.des;
      this.funNameIndex = eindex;
    },

    // 处理后面有数据的情况下取消或关闭，要缓存数据
    closeBtnClick() {
      if (this.endShow) {
        this.option.defaultValueEnd = this.curEventObj.defaultValueEnd;
      } else {
        this.option.defaultValue = this.curEventObj.defaultValue;
      }
    },
    confirm() {
      if (this.commonFunctionShow) {
        if (this.errorText) {
          return
        }
        if (this.funTypeIndex == 1) {
          this.option.functionResult.function = this.funcValue;
        } else if (this.funTypeIndex == 2) {
          this.cptOption.attribute.defaultValue = this.funcValue;
        }

      }
      this.cptFunShow = false;

    },
    fillValue(item) {
      if (this.commonFunctionShow) {
        const textareaEle = this.$refs.textarea
        this.commonFunctionFillValue(textareaEle, item)
      } else if (this.endShow) {
        const textareaEle = document.getElementById('inputEnd');
        this.textAreaCursor(textareaEle, item)
      } else {
        const textareaEle = document.getElementById('inputStart');
        this.textAreaCursor(textareaEle, item)
        console.log(this.option.defaultValueEN, '*')
      }
    },
    textareaBlur() {
      this.$nextTick(() => {
        //  this.$refs.inputStart.focus();
        if (this.commonFunctionShow) {

        } else if (this.cptFunShow) {
          if (this.endShow) {
            //  this.$refs.inputEnd.focus();
            document.getElementById('inputEnd').focus();
          } else {
            //  this.$refs.inputStart.focus();
            document.getElementById('inputStart').focus();
          }
        }
      });
    },
    // 光标插入方法，用原生textarea, selectionStart这个方法生效  endShow这个参数是因为日期控件，有开始日期与结束日期，所以需要两个文本
    textAreaCursor(ele, item) {
      const textareaStart = ele.selectionStart;
      const textareaEnd = ele.selectionEnd;
      if (textareaStart == textareaEnd) {
        console.log('位置相等')
        // 位置相等，代表没有用鼠标选中,直拉往向面添加，往光标的地方添加
        let startLength = this.endShow ? this.option.defaultValueEnd.length : this.option.defaultValue.length;
        if (textareaEnd == startLength) {
          console.log('光标等于文字长度，就是光标在这段文本的最后面，')
          if (this.endShow) {
            this.option.defaultValueEnd += item.valueText;
            // this.option.defaultValueEndEN += item.value;
          } else {
            this.option.defaultValue += item.valueText;
            // this.option.defaultValueEN += item.value;
          }
        } else {
          console.log('光标小于文字，光标在这段文本的中间')
          let startValue = this.endShow ? this.option.defaultValueEnd : this.option.defaultValue;
          startValue = startValue.split('');
          startValue.splice(textareaStart, startLength, item.valueText);
          startValue = startValue.join('');
          if (this.endShow) {
            this.option.defaultValueEnd = startValue;
            // this.option.defaultValueEndEN = item.value;
          } else {
            this.option.defaultValue = startValue;
            // this.option.defaultValueEN = item.value;
          }
        }
      } else {
        console.log('位置不相等，用鼠标选中的文本')
        let count = textareaEnd - textareaStart;
        let startValue = this.endShow ? this.option.defaultValueEnd : this.option.defaultValue;
        // let n = startValue.slice(textareaStart,textareaStart+count);// 选中的文字 
        startValue = startValue.split('');
        startValue.splice(textareaStart, count, item.valueText);
        startValue = startValue.join('');
        if (this.endShow) {
          this.option.defaultValueEnd = startValue;
          // this.option.defaultValueEndEN = item.value;
        } else {
          this.option.defaultValue = startValue;
          // this.option.defaultValueEN += item.value;
        }
      }
    },

    // 操作符处理
    onClickFunOperator(operator) {
      const textareaElement = this.$refs.textarea
      const start = textareaElement.selectionStart;
      const end = textareaElement.selectionEnd;

      let newValue = this.funcValue.slice(0, start) + operator.label + this.funcValue.slice(end);

      this.funcValue = newValue
      textareaElement.focus()
      setTimeout(() => {
        textareaElement.setSelectionRange(start + operator.label.length, start + operator.label.length);
      }, 0);

    },

    // 常用函数处理
    async commonFunctionFillValue(textareaEle, item) {
      let { value, index } = this.setTextValue(textareaEle, this.funcValue, item.valueText)
      // 插入新文本
      this.funcValue = value

      await this.setRangeIndex(textareaEle, index)

    },
    // 设置插入文本
    setTextValue(element, dataValue, newValue) {
      const start = element.selectionStart
      const end = element.selectionEnd

      element.focus()
      console.log(dataValue, this.newValue, 'dataValue')
      let textareaValue = dataValue.slice(0, start) + newValue + dataValue.slice(end)

      let index = textareaValue.indexOf('#import')
      let value = textareaValue.replace(/#import/g, '')
      return {
        value,
        index
      }
    },
    // 设置光标
    setRangeIndex(element, index) {
      return new Promise((resolve) => {
        setTimeout(() => {
          if ('selectionStart' in element === false) {
            var range = element.createTextRange();
            range.collapse(true);
            range.moveEnd('character', index);
            range.moveStart('character', index);
            range.select();
          } else {
            element.setSelectionRange(index, index);
          }

          resolve()
        }, 0);
      })
    },
    // 获取变量数据
    getFunctionVariables(option) {
      const { functionVariable } = option.currentCpt.cptOption.cptDataForm
      const copyFunctionVariable = JSON.parse(JSON.stringify(functionVariable))
      console.log(functionVariable, 'asdsdsd')
      let list = copyFunctionVariable.map(x => {
        x.isOpen = true
        x.childrenHeight = ((x.children && x.children.length || 0) * 22) + 'px'
        return x
      })
      this.functionVariables = list
    },
    // 打开变量
    onOpenVariables(item) {
      item.isOpen = !item.isOpen
    },
    // 选择变量
    async onClickVariables(item) {
      const textareaElement = this.$refs.textarea
      const start = textareaElement.selectionStart
      const end = textareaElement.selectionEnd
      const oldValue = textareaElement.value
      textareaElement.focus()
      console.log(start, end, 'end111')
      if (item.hasOwnProperty('field')) {
        let textareaValue = oldValue.slice(0, start) + `{${item.field}}` + oldValue.slice(end)
        // 插入新文本
        this.funcValue = textareaValue
        await this.setRangeIndex(textareaElement, start + item.field.length + 2)
      } else {
        let textareaValue = oldValue.slice(0, start) + `{${item.COLUMN_NAME}}` + oldValue.slice(end)
        // 插入新文本
        this.funcValue = textareaValue
        await this.setRangeIndex(textareaElement, start + item.COLUMN_NAME.length + 2)
      }

    },
    // 计算
    async onChangeTextarea() {
      if (this.funTypeIndex === 1) {
        const { result } = CommonFuncCalculate.init(this.funcValue, this.functionVariables);
        console.log(result, '??????');
        if (result === 'error' && this.commonFunctionShow && this.funcValue !== '') {
          this.errorText = '常用函数公式不符合(数值..)的参数要求';
        } else {
          this.errorText = false;
        }
      } else if (this.funTypeIndex === 2) {
        const result = await DatasetFuncValue.init(this.selectedDatasetValue, this.selectedDataset, this.currentCpt);
        this.option.funcResult = result;
        this.option.defaultValue = this.funcValue;
      }
    },
  },
};
</script>

<style scoped>
/* 整个t-dialog样式 */
.cpt-dialog /deep/.t-dialog {
  background-color: #20263b;
  border-radius: 4px;
  border: 1px solid transparent;
  height: 500px;
  width: 850px;
}

.cpt-dialog /deep/.t-dialog--default {
  padding: 0px !important;
}

.cpt-dialog /deep/.t-dialog__header {
  height: 40px;
  background-color: #292f45;
  padding-left: 20px;
  font-size: 14px;
  color: hsla(0, 0%, 100%, 0.9);
}

.cpt-dialog /deep/.t-dialog__close {
  padding-right: 18px;
  color: hsla(0, 0%, 100%, 0.9);
  font-size: 16px;
}

.cpt-dialog /deep/.t-dialog__close:hover {
  background-color: #292f45;
}

.cpt-dialog /deep/.t-dialog__body {
  height: calc(100% - 40px - 44px);
  box-sizing: border-box;
  padding: 10px 20px 0px;
}

.cpt-dialog /deep/.t-dialog__footer {
  height: 44px;
  line-height: 44px;
  padding: 0px 20px 0px 0px;
  box-sizing: border-box;
}

.cpt-dialog /deep/.t-dialog__cancel {
  height: 28px;
  background-color: rgba(44, 96, 219, 0.1);
  border-width: 0;
  color: #2c60db;
  padding: 0px 10px;
  font-size: 12px;
  border-radius: 2px;
}

.cpt-dialog /deep/.t-dialog__confirm {
  color: #fff;
  background-color: #2c60db;
  border: 1px solid #2c60db;
  height: 28px;
  padding: 0px 10px;
  font-size: 12px;
  border-radius: 2px;
}

/* .cpt_textarea {
  width: 100%;
  height: calc(100% - 35px);
}
.cpt_textarea /deep/.t-textarea__inner {
  resize: none !important;
  height: 127px;
  border: none;
} */

.cpt_btn {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.cpt_btn_item {
  background-color: #2684ff;
  height: 20px;
  margin: 0 5px 5px 0;
  width: calc((100% - 20px) / 5);
  min-width: calc((100% - 20px) / 5);
  max-width: calc((100% - 20px) / 5);
  text-align: center;
  cursor: pointer;
}

.cpt_btn_item:nth-child(5n + 5) {
  margin-right: 0;
}

.fun_top {
  height: 160px;
  margin-bottom: 10px;
}

.fun_top .t-col {
  width: 100%;
  height: 100%;
}

.fun_top .t-col .fun_top_flex {
  border: 1px solid #363e55;
  height: 100%;
}

.fun_top .t-col .none_right {
  border-left: none;
}

.fun_bottom {
  height: 230px;
}

.fun_bottom .t-col {
  width: 100%;
  height: 100%;
}

.fun_bottom .t-col .fun_bottom_flex {
  border: 1px solid #363e55;
  height: 100%;
}


.fun_bottom_flex .variables-wrap {
  overflow-y: scroll;
  height: calc(230px - 30px);
}

.fun_bottom_flex .variables-wrap .variables-title {
  height: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  color: hsla(0, 0%, 100%, 0.9);
  font-size: 12px;
  padding: 0px 15px;
  padding-right: 10px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;

}

.variables-title span {
  display: inline-block;
  max-width: 110px;
  overflow: hidden;
  /* 隐藏超出的内容 */
  text-overflow: ellipsis;
  /* 使用省略号代替隐藏的内容 */
  white-space: nowrap;
  /* 禁止文本换行 */
  padding-right: 3px;
  box-sizing: border-box;
}

.variables-title i {
  font-style: normal;
  min-width: 30px;
  white-space: nowrap;
}

.fun_bottom_flex .variables-wrap .active-title:before {
  transform: translateY(-50%) rotate(90deg) !important;
  left: 3.5px !important;
  transform-origin: center center;
}

.fun_bottom_flex .variables-wrap .variables-title:before {
  content: '';
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-right: 3px solid transparent;
  /* 左边框透明 */
  border-bottom: 3px solid transparent;
  /* 右边框透明 */
  border-left: 4px solid #fff;
  border-top: 3px solid transparent;
  /* 底边框有颜色，决定三角形大小和颜色 */
  transition: all .3s;
}

.fun_bottom_flex .variables-wrap .variables-item-title {
  cursor: pointer;
  padding-left: 25px;
  height: 22px;
  line-height: 22px;
  overflow: hidden;

}

.fun_bottom_flex .variables-wrap .variables-item-title span {
  overflow-x: hidden;
  /* 隐藏超出的内容 */
  text-overflow: ellipsis;
  /* 使用省略号代替隐藏的内容 */
  white-space: nowrap;
  /* 禁止文本换行 */
  width: 145px;
  display: inline-block;
  height: 100%;
}

.fun_bottom_flex .variables-wrap .variables-item-title:active {
  background: #363d55;
}

.fun_bottom_flex .variables-wrap .is-open {
  overflow: auto !important;
  /* height: 100% !important; */
  height: var(---height) !important;
}

/* 隐藏滚动条并自定义滚动条样式，使滚动条不可见但仍可交互 */
.fun_bottom_flex .variables-wrap .variables-item-children::-webkit-scrollbar {
  width: 0;
  /* 隐藏滚动条宽度 */
  height: 0;
  /* 对于垂直滚动条 */
}

.fun_bottom_flex .variables-wrap .variables-item-children {
  overflow: hidden;
  height: 0;
  transition: height .3s;
}

.fun_header {
  height: 30px;
  border-bottom: 1px solid #363e55;
  background-color: #292f45;
  color: hsla(0, 0%, 100%, 0.9);
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 5px;
}

.fun_header /deep/ .t-form__label {
  width: 50px !important;
  padding-right: 0px !important;
}

.fun_header /deep/ .t-form__controls {
  margin-left: 49px !important;
}

.fun_header /deep/ .t-switch {
  margin-left: 2px !important;
}

.result-error {
  color: rgb(230, 82, 81);
}


.fun_header_title {
  width: 100%;
  padding: 5px 5px 0px 5px;
  box-sizing: border-box;
}

.fun_name {
  width: 100%;
  height: 200px;
  overflow-y: auto;
}

.fun_name_item {
  height: 24px;
  width: 100%;
  color: hsla(0, 0%, 100%, 0.9);
  font-size: 12px;
  padding: 0px 5px;
  box-sizing: border-box;
  cursor: pointer;
}

.fun_name_item span {
  display: inline-block;
  width: 120px;
  height: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fun_p {
  padding: 0px 5px;
}

.active {
  background-color: #363d55;
}

#inputStart,
#inputEnd,
#textarea {
  width: 100%;
  height: 127px;
  background: #20263b;
  border: none;
  color: hsla(0, 0%, 100%, 0.9);
  font-size: 12px;
  resize: none !important;
  padding: 5px;
  box-sizing: border-box;
}
</style>
